/**
 * Home Screen — Hauptmenü mit Hero-Title.
 */
import { div, h1, p, button, el, input } from '../../utils/domHelpers.js';
import { router } from '../../core/router.js';
import { lobbyService } from '../../services/lobbyService.js';
import { storageService } from '../../services/storageService.js';
import { eventBus } from '../../core/eventBus.js';
import { toast } from '../components/toast.js';

export function renderHomeScreen() {

  const savedName = storageService.get('playerName', '');
  const highScore = storageService.getSoloHighScore();

  const nameInput = input({
    class: 'glass-input',
    type: 'text',
    placeholder: 'Dein Spielername',
    maxlength: 16,
    value: savedName,
    oninput: (e) => storageService.set('playerName', e.target.value.trim())
  });

  const codeInput = input({
    class: 'glass-input glass-input--code',
    type: 'text',
    placeholder: 'CODE',
    maxlength: 6,
    style: { marginTop: '8px' }
  });

  // Sicherstellen, dass ein Name eingegeben ist
  const getName = () => {
    const name = nameInput.value.trim();
    if (name.length < 2) {
      toast.error('Bitte gib einen Namen ein (min. 2 Zeichen)');
      nameInput.focus();
      return null;
    }
    storageService.set('playerName', name);
    return name;
  };

  // Lobby-Created Event abfangen und navigieren
  const offCreated = eventBus.on('server:lobby_created', () => router.navigate('/lobby'));
  const offUpdated = eventBus.on('server:lobby_updated', () => router.navigate('/lobby'));
  // Cleanup bei Routenwechsel
  eventBus.on('route:before-change', () => { offCreated(); offUpdated(); });

  const panel = el('div', { class: 'glass-panel stagger' }, [
    div({ class: 'home-hero' }, [
      h1({ class: 'home-title' }, ['MATH PUZZLE ARENA']),
      p({ class: 'home-subtitle' }, ['⚡ Cyberpunk Math Riddles ⚡']),
    ]),

    nameInput,

    div({ class: 'home-menu' }, [
      button({
        class: 'btn btn-primary btn-lg btn-block pulse-glow',
        onclick: () => router.navigate('/solo')
      }, ['🎯 Solo spielen']),

      button({
        class: 'btn btn-secondary btn-block',
        onclick: () => {
          const name = getName(); if (!name) return;
          lobbyService.createLobby(name);
          toast.info('Lobby wird erstellt...');
        }
      }, ['⚔️ Lobby erstellen']),

      div({ class: 'flex gap-2', style: { marginTop: '8px' } }, [
        codeInput,
        button({
          class: 'btn btn-ghost',
          onclick: () => {
            const name = getName(); if (!name) return;
            const code = codeInput.value.trim().toUpperCase();
            if (code.length !== 6) return toast.error('Code muss 6 Zeichen lang sein');
            lobbyService.joinLobby(name, code);
            toast.info('Verbinde mit Lobby...');
          }
        }, ['Beitreten →']),
      ]),
    ]),

    div({ class: 'divider' }),

    div({ class: 'flex-between', style: { fontSize: '0.85rem' } }, [
      el('span', { class: 'mono', style: { color: 'var(--text-muted)' } }, ['SOLO HIGHSCORE']),
      el('span', { class: 'mono glow-text-cyan' }, [String(highScore)]),
    ]),
  ]);

  return panel;
}
